import { TOGGLE_DESTINATION_NOT_REACH_YET } from "./displayDestinationNotReachYetReducer"

export const toggleDestinationNotReachYet = (value) => ({
    type: TOGGLE_DESTINATION_NOT_REACH_YET,
    payload: value
})

